declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export function publishAnalyticsEvent(
  name: string,
  data: Record<string, unknown> = {},
): void {
  const normalized = normalizeGaParams(data)

  try {
    window.Shopify?.analytics?.publish?.(name, normalized)
  } catch {
    // Unavailable in theme editor or before Shopify loads analytics
  }

  try {
    window.gtag?.('event', name, normalized)
  } catch {
    // gtag optional; GA may be wired through a custom pixel instead
  }
}

/** GA4-safe param values: string | number | boolean only. */
function normalizeGaParams(
  data: Record<string, unknown>,
): Record<string, string | number | boolean> {
  const out: Record<string, string | number | boolean> = {}
  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value
    } else if (value == null) {
      continue
    } else {
      out[key] = String(value)
    }
  }
  return out
}

export type WishlistAnalyticsSource =
  | 'product_page'
  | 'wishlist_panel'
  | 'cart_save_for_later'

export function trackWishlistEvent(
  name: string,
  data: Record<string, unknown> = {},
): void {
  publishAnalyticsEvent(name, data)
}

export function trackCartLegacyEvent(
  name: string,
  data: Record<string, unknown> = {},
): void {
  publishAnalyticsEvent(name, data)
}
